import {DceAjaxResponseProcessor} from "dce-ajax";

export default class DceWireXStyleProcessor implements DceAjaxResponseProcessor {

    execute(resposne: any): void {

        let style = resposne.headers['x-wire-style']
        let styleHash = resposne.headers['x-wire-style-hash']

        if(style && styleHash){
            let stylehashElement = document.getElementById(styleHash);
            if(!stylehashElement) {
                document.head.insertAdjacentHTML("beforeend", style);
            }
        }

    }

}
